<template>
  <div>
    <multiselect
      v-model="selected"
      :options="filterVariable"
      :searchable="true"
      track-by="name"
      label="name"
      @input="onChange"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters, mapMutations } from 'vuex'
export default {
  props: ['value', 'dataName'],
  data() {
    return {
      selected: null
    }
  },
  components: {
    Multiselect
  },
  mounted() {
    var val = this.value.find(el => {
      return this.dataName == el.name
    })
    if (val) {
      this.selected = this.filterVariable.find(el => {
        return el.value == val.value
      })
    } else {
      this.selected = null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loadingFlowList: 'getLoadingFlowList',
      variable: 'getVariableList',
      loadingVariableList: 'getLoadingVariableList',
      selectedFlow: 'getFlowId'
    }),
    filterVariable() {

      var vm = this
      var variable = []
      if (vm.variable) {
        variable = vm.variable.filter(el => {
          return el.flowid == 0 || (vm.selectedFlow && el.flowid == vm.selectedFlow.id)
        })
      }
      var result = []
      variable.map(el => {
        result.push({
          name: el.name,
          value: el.name
        })
      })
      return result
    }
  },
  methods: {
    onChange(value) {
      // console.log(value)
      var valIndex = this.value.findIndex(el => {
        return this.dataName == el.name
      })
      var data = null
      if (valIndex != -1) {
        data = this.value
        // console.log(data[valIndex])
        this.$set(data[valIndex], 'value', value ? value.value : null)
      } else {
        data = this.value
        data.push({
          name: this.dataName,
          value: value ? value.value : null
        })
      }
      // console.log(data)
      this.$emit('input', data)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/ApiResponseManage.vue